/* Suche – eine Komponente <rd-suche> für Desktop-Feld, mobiles Vollbild-Overlay und Ergebnisseite (Navigation-Suche-Runde2-1011 §8).
   Leerzustand beim Fokus, Vorschläge ab 2 Zeichen nach 200 ms (Section rd-suche-vorschlag über Shopify Predictive Search),
   Pfeiltasten/Enter/Esc (Baymard), ergänzter Teil fett, Enter ohne Auswahl: passende Kategorie/Marke direkt (data-direkt).
   Dazu auf der Ergebnisseite: Filter-Dropdowns, Dialog, Sortierung, „Weitere Treffer laden“, „Meintest du …?“.
   Sleeks Such-Drawer wird nicht mehr geöffnet: Klicks auf [aria-controls="SearchDrawer"] öffnen diese Komponente. */
(function () {
  if (window.customElements && customElements.get('rd-suche')) return;
  var ROT = /\b(gin|rum|tequila|whisky|whiskey|wodka|vodka|cognac|brandy|amaretto|champagner|champagne|prosecco|cava|lillet|aperol|campari)\b|champagn/i;
  var nr = 0;

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sichtbar(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  class RdSuche extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bereit) return;
      this.dataset.bereit = '1';
      this.uid = 'rds' + (++nr);
      this.kontext = this.dataset.kontext || 'kopf';
      this.feld = this.querySelector('[data-rd-such-feld]');
      this.form = this.querySelector('[data-rd-such-form]');
      this.panel = this.querySelector('[data-rd-such-panel]');
      this.leer = this.querySelector('[data-rd-such-leer]');
      this.erg = this.querySelector('[data-rd-such-erg]');
      this.status = this.querySelector('[data-rd-such-status]');
      this.ov = this.querySelector('[data-rd-such-ov]');
      this.cache = {};
      this.aktiv = -1;
      this.timer = null;
      this.letzte = null;
      if (!this.feld) return;
      var self = this;
      this.feld.addEventListener('focus', function () { self.auf(); });
      this.feld.addEventListener('input', function () {
        clearTimeout(self.timer);
        self.timer = setTimeout(function () { self.zeige(); }, 200);
      });
      this.feld.addEventListener('keydown', function (e) { self.taste(e); });
      this.form.addEventListener('submit', function (e) { self.absenden(e); });
      this.addEventListener('mousemove', function (e) {
        var o = e.target.closest('[role="option"]');
        if (o && self.erg.contains(o)) self.markiere(self.optionen().indexOf(o), true);
      });
      if (this.kontext !== 'overlay') {
        document.addEventListener('click', function (e) { if (!self.contains(e.target)) self.zu(); });
        this.addEventListener('focusout', function (e) { if (e.relatedTarget && !self.contains(e.relatedTarget)) self.zu(); });
      } else {
        this.querySelectorAll('[data-rd-such-zu]').forEach(function (b) { b.addEventListener('click', function () { self.overlayZu(); }); });
        /* 12.10. (N4): „In den Warenkorb“ in den Bestseller-Karten → Overlay schließen, damit der Seiten-Warenkorb sichtbar wird */
        this.addEventListener('submit', function (e) {
          if (e.target && e.target.closest && e.target.closest('[data-rd-such-best]')) setTimeout(function () { self.overlayZu(); }, 0);
        });
      }
    }
    auf() {
      if (this.kontext === 'overlay') return;
      this.panel.hidden = false;
      this.feld.setAttribute('aria-expanded', 'true');
      this.classList.add('is-offen');
      if (this.feld.value.trim().length < 2) this.leerZeigen();
    }
    zu() {
      if (this.kontext === 'overlay') return;
      this.panel.hidden = true;
      this.feld.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-offen');
      this.markiere(-1);
    }
    overlayAuf(opener) {
      if (!this.ov) return;
      this.opener = opener || null;
      this.ov.hidden = false;
      document.documentElement.classList.add('rd-such-offen');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      if (this.feld.value.trim().length < 2) this.leerZeigen();
      this.bestLaden();
      var f = this.feld;
      /* sofort im Klick fokussieren (iOS öffnet die Tastatur nur in der Nutzer-Geste), danach absichern gegen Fokus-Rückgabe anderer Drawer */
      try { f.focus({ preventScroll: true }); } catch (x) { f.focus(); }
      setTimeout(function () { if (document.activeElement !== f) f.focus(); }, 80);
    }
    overlayZu() {
      if (!this.ov) return;
      this.ov.hidden = true;
      document.documentElement.classList.remove('rd-such-offen');
      if (this.opener) { this.opener.setAttribute('aria-expanded', 'false'); this.opener.focus(); }
    }
    /* 12.10. (Abnahme-Runde 3, N4): Leerzustand mobil unten mit 4 Bestseller-Karten füllen – erst beim Öffnen laden (Section Rendering) */
    bestLaden() {
      var w = this.querySelector('[data-rd-such-best]');
      if (!w || w.dataset.geladen || !window.fetch) return;
      w.dataset.geladen = '1';
      var u = new URL(w.dataset.url || '/', location.origin);
      u.searchParams.set('section_id', 'rd-suche-leer');
      fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).then(function (html) {
        var n = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rd-such-best-inhalt]');
        if (n) w.appendChild(document.importNode(n, true));
      }).catch(function () { delete w.dataset.geladen; });
    }
    leerZeigen() {
      if (this.leer) this.leer.hidden = false;
      this.erg.hidden = true;
      this.erg.innerHTML = '';
      this.feld.setAttribute('aria-expanded', this.kontext === 'overlay' || !this.panel.hidden ? 'true' : 'false');
      this.markiere(-1);
      this.letzte = null;
    }
    url(q) {
      var u = new URL(this.dataset.url || '/search/suggest', location.origin);
      u.searchParams.set('q', q);
      u.searchParams.set('section_id', 'rd-suche-vorschlag');
      u.searchParams.set('resources[type]', 'product,collection,article,query');
      u.searchParams.set('resources[limit]', '10');
      u.searchParams.set('resources[limit_scope]', 'each');
      u.searchParams.set('resources[options][unavailable_products]', 'hide');
      u.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
      return u.toString();
    }
    holen(q) {
      var key = q.toLowerCase();
      if (this.cache[key]) return this.cache[key];
      var p = fetch(this.url(q), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('[data-rd-such-v]');
      });
      this.cache[key] = p;
      p.catch(function () {});
      return p;
    }
    zeige() {
      var q = this.feld.value.trim();
      if (this.kontext !== 'overlay' && this.panel.hidden) this.auf();
      if (q.length < 2) { this.leerZeigen(); return; }
      var self = this;
      this.holen(q).then(function (v) {
        if (self.feld.value.trim() !== q) return;
        self.letzte = v;
        if (!v) return;
        var node = document.importNode(v, true);
        node.querySelectorAll('[id]').forEach(function (el) { el.id = self.uid + '-' + el.id; });
        node.querySelectorAll('[aria-labelledby]').forEach(function (el) { el.setAttribute('aria-labelledby', self.uid + '-' + el.getAttribute('aria-labelledby')); });
        self.hervorheben(node, q);
        self.erg.innerHTML = '';
        self.erg.appendChild(node);
        if (self.leer) self.leer.hidden = true;
        self.erg.hidden = false;
        self.feld.setAttribute('aria-expanded', 'true');
        self.markiere(-1);
        var n = self.optionen().length;
        if (self.status) self.status.textContent = n ? n + (n === 1 ? ' Vorschlag' : ' Vorschläge') : 'Keine Vorschläge';
      }).catch(function () {});
    }
    /* Baymard: der ergänzte Teil fett, nicht der getippte */
    hervorheben(node, q) {
      var ql = q.toLowerCase();
      node.querySelectorAll('[data-hl]').forEach(function (a) {
        var tn = null;
        a.childNodes.forEach(function (c) { if (c.nodeType === 3 && c.textContent.trim()) tn = c; });
        if (!tn) return;
        var t = tn.textContent, i = t.toLowerCase().indexOf(ql);
        if (i < 0) { var b0 = document.createElement('b'); b0.textContent = t; tn.replaceWith(b0); return; }
        var span = document.createElement('span');
        span.innerHTML = (i > 0 ? '<b>' + esc(t.slice(0, i)) + '</b>' : '') + esc(t.slice(i, i + q.length)) + (i + q.length < t.length ? '<b>' + esc(t.slice(i + q.length)) + '</b>' : '');
        tn.replaceWith(span);
      });
    }
    optionen() {
      return Array.prototype.slice.call(this.erg.querySelectorAll('[role="option"]')).filter(sichtbar);
    }
    markiere(i, maus) {
      var os = this.optionen();
      os.forEach(function (o) { o.classList.remove('is-aktiv'); o.setAttribute('aria-selected', 'false'); });
      this.aktiv = i;
      if (i < 0 || i >= os.length) { this.feld.removeAttribute('aria-activedescendant'); this.aktiv = -1; return; }
      var o = os[i];
      o.classList.add('is-aktiv');
      o.setAttribute('aria-selected', 'true');
      this.feld.setAttribute('aria-activedescendant', o.id);
      if (!maus && o.scrollIntoView) o.scrollIntoView({ block: 'nearest' });
    }
    taste(e) {
      var os = this.optionen();
      if (e.key === 'ArrowDown') {
        if (!os.length) return;
        e.preventDefault();
        this.markiere(this.aktiv + 1 >= os.length ? 0 : this.aktiv + 1);
      } else if (e.key === 'ArrowUp') {
        if (!os.length) return;
        e.preventDefault();
        this.markiere(this.aktiv - 1 < 0 ? os.length - 1 : this.aktiv - 1);
      } else if (e.key === 'Escape') {
        if (this.kontext === 'overlay') { e.preventDefault(); this.overlayZu(); }
        else if (!this.panel.hidden) { e.preventDefault(); this.zu(); }
      } else if (e.key === 'Enter' && this.aktiv >= 0 && os[this.aktiv]) {
        e.preventDefault();
        var a = os[this.aktiv].querySelector('a');
        if (a) { a.click(); }
      }
    }
    absenden(e) {
      var q = this.feld.value.trim();
      if (!q) { e.preventDefault(); this.feld.focus(); return; }
      if (q.length < 2) return;
      e.preventDefault();
      var self = this, form = this.form, gesendet = false;
      function weiter(v) {
        if (gesendet) return; gesendet = true;
        var d = v && v.getAttribute('data-direkt');
        if (d) { location.href = d; return; }
        HTMLFormElement.prototype.submit.call(form);
      }
      setTimeout(function () { weiter(null); }, 1200);
      this.holen(q).then(weiter, function () { weiter(null); });
    }
  }
  customElements.define('rd-suche', RdSuche);

  /* Öffner: Lupe im Kopf (mobil) und alle alten Sleek-Öffner (z. B. mobile Leiste) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rd-such-auf], [aria-controls="SearchDrawer"]');
    if (!b) return;
    var ov = document.querySelector('rd-suche[data-kontext="overlay"]');
    var kopf = document.querySelector('rd-suche[data-kontext="kopf"]');
    var desktop = window.matchMedia('(min-width: 1024px)').matches;
    if (desktop && kopf && sichtbar(kopf)) { e.preventDefault(); e.stopPropagation(); kopf.querySelector('[data-rd-such-feld]').focus(); return; }
    if (ov) { e.preventDefault(); e.stopPropagation(); ov.overlayAuf(b.hasAttribute('data-rd-such-auf') ? b : null); }
  }, true);

  /* ---------- Ergebnisseite (gleiches Verhalten wie die Kollektion) ---------- */
  function seite() {
    var root = document.getElementById('rd-such-seite');
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-rd-kol-open]');
      if (o) { var d = document.getElementById(o.getAttribute('data-rd-kol-open')); if (d && d.showModal) d.showModal(); return; }
      var c = e.target.closest('[data-rd-kol-close]'); if (c) { c.closest('dialog').close(); return; }
      if (e.target.tagName === 'DIALOG') { e.target.close(); return; }
      var m = e.target.closest('[data-rd-kol-more]');
      if (m && window.fetch) {
        e.preventDefault(); m.setAttribute('aria-busy', 'true'); m.textContent = 'Lädt …';
        var u = new URL(m.href, location.href); u.searchParams.set('section_id', root.dataset.section);
        fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          [['[data-rd-kol-grid]'], ['[data-rd-kol-bald-list]']].forEach(function (s) {
            var g = root.querySelector(s[0]), ng = doc.querySelector(s[0]);
            if (ng && !g && s[0] === '[data-rd-kol-bald-list]') {
              var sec = doc.querySelector('[data-rd-kol-bald]'), ziel = root.querySelector('.rd-such-alle');
              if (sec && ziel) ziel.after(document.importNode(sec, true));
              return;
            }
            if (g && ng) Array.prototype.forEach.call(ng.children, function (li) { g.appendChild(document.importNode(li, true)); });
          });
          root.querySelectorAll('[data-rd-kol-more-wrap]').forEach(function (w, i) { if (i > 0) w.remove(); });
          var w = root.querySelector('[data-rd-kol-more-wrap]'), nw = doc.querySelector('[data-rd-kol-more-wrap]');
          if (w) { if (nw) w.replaceWith(document.importNode(nw, true)); else w.remove(); }
        }).catch(function () { location.href = m.href; });
      }
    });
    root.querySelectorAll('form[data-rd-kol-auto]').forEach(function (f) { f.addEventListener('change', function () { f.submit(); }); });
    var dds = root.querySelectorAll('[data-rd-kol-dd]');
    dds.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) dds.forEach(function (o) { if (o !== d) o.open = false; }); }); });
    document.addEventListener('click', function (e) { dds.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; }); });
    /* „Meintest du …?“: erster Suchvorschlag zu den ersten 4 Buchstaben, ohne ROT-Wort (Baymard: 69 % ohne Tippfehler-Hilfe) */
    var mt = root.querySelector('[data-rd-such-meint]');
    if (mt && window.fetch) {
      var q = (mt.getAttribute('data-q') || '').trim();
      if (q.length >= 4) {
        var u = new URL((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search/suggest.json', location.origin);
        u.searchParams.set('q', q.slice(0, 4));
        u.searchParams.set('resources[type]', 'query');
        u.searchParams.set('resources[limit]', '6');
        fetch(u.toString()).then(function (r) { return r.json(); }).then(function (j) {
          var qs = (((j || {}).resources || {}).results || {}).queries || [];
          var t = null;
          for (var i = 0; i < qs.length; i++) {
            var x = (qs[i].text || '').trim();
            if (x && x.toLowerCase() !== q.toLowerCase() && !ROT.test(x)) { t = x; break; }
          }
          if (!t) return;
          var h = '/search?q=' + encodeURIComponent(t) + '&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last';
          mt.innerHTML = 'Meintest du <a href="' + esc(h) + '">„' + esc(t) + '“</a>?';
          mt.hidden = false;
        }).catch(function () {});
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', seite); else seite();
  document.addEventListener('shopify:section:load', seite);
})();
